import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { closePopup } from '@common/reducers/SubscriptionPopupReducer';

import UpgradeBox from '../upgrade-box/upgrade-box';
import { CommonRootState } from '@common/types/common-root-state-type';
import { Dialog, DialogContent } from '@/components/ui/dialog';

export interface ISubscriptionUpgradePopup {
}

export function SubscriptionUpgradePopup(props: ISubscriptionUpgradePopup) {
    const dispatch = useAppDispatch()
    const isOpen = useSelector((state: CommonRootState) => state.SubscriptionPopupReducer.isOpen);

    const closeAccessFormPopup = () => {
        dispatch(closePopup())
    }

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && closeAccessFormPopup()}>
            <DialogContent
                className="w-full !p-0 max-w-[min(90vw,500px)] max-h-[90vh] overflow-hidden"
                style={{
                    backgroundColor: 'var(--color-surface, #ffffff)',
                    color: 'var(--color-text, #111827)',
                    padding: 0,
                }}
            >
                <UpgradeBox />
            </DialogContent>
        </Dialog>
    );
}
